import(/* webpackMode: "eager" */ "/workspace/src/app/events/2025spring/detail/page.tsx");
